import { Card, Col, Row } from 'react-bootstrap';
import SingleClientTrend from './components/SingleClientTrend';
import AllClientsTrendsMeanChart from './components/AllClientsTrendsMeanChart';
import AllReportsFoldersTable from './components/AllReportsFolders';
import AllReportsIndicators from './components/AllReportsIndicators';
import { useNavigate } from 'react-router-dom';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';

const CoachingStatsDashboard = () => {

    const { t } = useTranslation();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Analytics.page_title'),
            url: '/analytics'
        },
        {
            label: t('CoachingStatsDashboard.page_title'),
            active: true
        }
    ];


    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />




            <Card className='border border-light rounded-5' >
                <Card.Body>

                    <Row className="mb-4 gy-3 justify-content-between">
                        <Col xs={12} xxl={12} className="mb-6">
                            <h3>{t("CoachingStatsDashboard.personal_meeting_trends")}</h3>
                            <AllReportsIndicators />
                            <AllClientsTrendsMeanChart />
                        </Col>
                    </Row>

                    <Row className="mb-4 gy-3 justify-content-between">
                        <Col xs={12} xxl={12} className="mb-6">
                            <h3>{t("CoachingStatsDashboard.compare_trends")}</h3>
                            <SingleClientTrend />
                        </Col>
                    </Row>

                    <Row className="mb-4 gy-3 justify-content-between">
                        <Col xs={12} xxl={12} className="mb-6">
                            <h3>Coaching activities</h3>
                            <p className="text-700 mb-1">Number of clients, number of sessions, etc</p>
                            <AllReportsFoldersTable />
                        </Col>
                    </Row>

                </Card.Body>
            </Card>


        </>
    );
};

export default CoachingStatsDashboard;
